

































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

/**
 * API
 */
import cashItemsAPI from "@/api/cash-items";
import subFamilliesAPI from "@/api/sub-families";
import formulasAPI from "@/api/formulas";
/**
 * Components
 */
import ShopItemCard from "./ShopItemCard.vue";
import ShopFormulaItemCard from "./ShopFormulaItemCard.vue";
/**
 * Types
 */
import { Cart } from "../store";

/**
 * Composant d'explorateur d'articles.
 */
@Component({
  components: { ShopItemCard, ShopFormulaItemCard }
})
export default class ShopBrowser extends Vue {
  /** Propriétés */
  @Prop()
  cart!: Cart;

  @Prop()
  handleItemAdd!: (itemId: number, itemType: number) => Promise<void>;

  @Prop()
  handleFormulaAdd!: (itemId: number, items: any[]) => Promise<void>;

  @Prop()
  handleItemRemove!: (itemId: number) => Promise<void>;

  @Prop({ default: false })
  isActionLoading!: boolean;

  @Prop()
  dateBooked: Date | null = null;

  /** Attributs */
  isLoading = false;

  // les Formules
  formulaMode = false;
  formulaSteps = 0;
  formulaName = "";
  formulaID = 0;
  formulaStepper = 1;

  isFormulaComplete = false;

  // les pools de Formule
  displayedFormulaPools: any[] = [];

  // les sous familles
  displayedSubFamillies: any[] = [];

  // Les items affichés à l'écran

  displayedCashItems: any[] = [];

  // Le champ texte de recherche
  researchField: string = "";

  // Pagination
  nbPages = 0;
  currentPage = 1;
  currentSubFamId = null;
  currentSubFamLabel = null;

  /** Méthodes */
  async created() {
    //await this.executeResearch("", this.currentPage, this.currentSubFamId);
  }

  async reloadItems() {
    await this.executeResearch(
      this.researchField,
      this.currentPage,
      this.currentSubFamId
    );
  }

  async executeResearch(research: string, page: number, subFam: number | null) {
    this.isLoading = true;
    const getAllSubFamilly = await subFamilliesAPI.GetAllSubFamilies(this.dateBooked);
    this.displayedSubFamillies = getAllSubFamilly.items;

    const getAllResult = await cashItemsAPI.getAll(
      research,
      page,
      subFam,
      this.dateBooked
    );

    // calcul du reste d'article en fonction des quantités max
    for (let cItem of getAllResult.items) {
      this.CalcRemaining(cItem);
      //alert(cItem.remaining + " " + cItem.maxBooking);
    }

    this.displayedCashItems = getAllResult.items;

    const maxNbItems = getAllResult.maxNbItems;
    const nbItemsPerPage = getAllResult.nbItemsPerPage;
    this.nbPages = Math.ceil(maxNbItems / nbItemsPerPage);
    this.isLoading = false;
  }

  // sélection d'une formule
  async executeFormula(itemId: number) {
    const getAllFormulaSteps = await formulasAPI.GetFormulaPools(
      itemId,
      this.dateBooked
    );
    this.displayedFormulaPools = getAllFormulaSteps.items;
    this.checkFormula(this.displayedFormulaPools);
    this.formulaStepper = 1;
    this.formulaSteps = this.displayedFormulaPools.length;
    if (this.formulaSteps > 0) {
      this.formulaMode = true;
      for (let cItem of this.displayedCashItems) {
        if (cItem.id === itemId) {
          this.formulaID = itemId;
          this.formulaName = cItem.shortLabel ? cItem.shortLabel : cItem.label;
          break;
        }
      }
    }

    this.isActionLoading = false;
  }

  // affecte le remaining de chaque article avec les max réservable diminué des articles présent dans la carte/ticket
  // et retourne false si une étape ne peut être complétée par manque d'article
  // cette fonction peut être juste utilisée pour affecter le remaining
  async checkFormula(FormulasPools: any[]) {
    let ret = true;
    for (let cPool of FormulasPools) {
      let nbArtInThisPoolCounter = 0;
      // pour chaque article du pool
      for (let cItem of cPool.cashItems) {
        // traitement des maxréservables
        this.CalcRemaining(cItem);
        if (cItem.remaining > 0 || cItem.maxBooking == -1) {
          nbArtInThisPoolCounter += 1;
        }
      }
      if (nbArtInThisPoolCounter > 0) {
        ret = false;
      }
    }
    return ret;
  }

  // enregsitrement de la formule dans la carte/ticket
  async handleFormulaAddClick() {
    try {
      //let formulaItems =  this.displayedFormulaPools.forEach(x=> x.cashItems.filter(it=> it == true ));
      let formulaItems = new Array();
      for (let cPool of this.displayedFormulaPools) {
        for (let cItem of cPool.cashItems) {
          if (cItem.isSelected) {
            formulaItems.push(cItem);
          }
        }
      }
      let myformulaID = this.formulaID;
      this.handleCancelFormulaClick();
      await this.handleFormulaAdd(myformulaID, formulaItems);
      //this.isActionLoading = false;
    } catch (error) {
      this.isActionLoading = false;
      alert(error);
      throw error;
    }
  }

  // clic sur article de la formule en cours de sélection
  async handleformulaItem(poolId: number, itemId: number) {
    let changestep = false;
    try {
      this.isFormulaComplete = false;
      let ValidStepCounter = 0;
      for (let cPool of this.displayedFormulaPools) {
        let nbArtSelectedInThisPoolCounter = 0;
        // pour chaque article du pool

        for (let cItem of cPool.cashItems) {
          // traitement des maxréservables
          this.CalcRemaining(cItem);

          // si l'article est dispo

          // gestion des quantités par pool au moment de la sélection
          if (poolId == cPool.id) {
            // si disponible
            
              let cntSelectedItem = this.countSelectedItemInPool(
                cPool.cashItems
              );
              // on supprime arbitrairement de la sélection l'un des articles du pool qui n'est pas celui en cours de sélection
              if (itemId != cItem.id && cntSelectedItem > cPool.qte) {
                cItem.isSelected = false;
                cntSelectedItem -= 1;
              }
          }

          //comptabilisation des articles selectionnés
          if (cItem.isSelected) {
            nbArtSelectedInThisPoolCounter += 1;
          }

          // alert(nbArtSelectedInThisPoolCounter + " ? " + cPool.qte + " = " + cPool.stepComplete);
        }
        //validation de l'étape
        if (nbArtSelectedInThisPoolCounter == cPool.qte) {
          ValidStepCounter += 1;
          cPool.stepComplete = true;
          if (
            this.formulaStepper < this.displayedFormulaPools.length &&
            poolId == cPool.id
          ) {
            changestep = true;
          }
        } else {
          cPool.stepComplete = false;
        }
      }
      //validation de la formule
      if (ValidStepCounter == this.displayedFormulaPools.length) {
        this.isFormulaComplete = true;
      }
    } catch (error) {
      //      alert(error);
      throw error;
    }
    // changement automatique de step
    // désactivé car l'action de changer de step manuellement est une forme de validation
    if (changestep) {
      // this.formulaStepper += 1;
    }
  }

  countSelectedItemInPool(poolItemList: any) {
    try {
      let cnt = 0;
      for (let cItem of poolItemList) {
        if (cItem.isSelected) {
          cnt += 1;
        }
      }
      return cnt;
    } catch (error) {
      alert(error);
      throw error;
    }
    return 0;
  }

  async onPageChanged() {
    await this.executeResearch(
      this.researchField,
      this.currentPage,
      this.currentSubFamId
    );
  }

  async handleSubmitResearch() {
    this.currentPage = 1;
    await this.executeResearch(
      this.researchField,
      this.currentPage,
      this.currentSubFamId
    );
  }

  async handleSubFamClick(subfamid: any, SubFamLabel: any) {
    this.currentSubFamId = subfamid;
    this.currentSubFamLabel = SubFamLabel;
    this.currentPage = 1;
    await this.executeResearch(
      this.researchField,
      this.currentPage,
      this.currentSubFamId
    );
  }

  handleCancelFormulaClick() {
    this.isFormulaComplete = false;
    this.formulaName = "";
    this.formulaID = 0;
    this.formulaSteps = 0;
    this.formulaMode = false;
  }

  CalcRemaining(cItem: any) {
    if (cItem != null) {
      let qtyOfThisItemInCart = this.cart.items
        .filter(x => x.id === cItem.id)
        .reduce((sum, current) => sum + current.quantity, 0);
        cItem.remaining = cItem.initialRemaining - qtyOfThisItemInCart; 
    }
  }

  async handleItemAddCatch(itemId: number, itemType: number) {
    this.isActionLoading = true;
    try {
      //type formule
      if (itemType == 2) {
        await this.executeFormula(itemId);
        this.isActionLoading = false;
        // type article de formule (20 n'existe pas pour de vrai)
      } else if (itemType == 20) {
      } else {
        await this.handleItemAdd(itemId, itemType);

        this.isActionLoading = false;
      }
    } catch (error) {
      this.isActionLoading = false;
      alert(error);
      throw error;
    }
  }

  async isArticleVisible() {}
}
